import { combineEpics } from 'redux-observable'
import { getAdvisorsEpic } from 'components/features/coaching/advisorStore/epics/getAdvisorsEpic'
import { createMeetingEpic } from 'components/features/coaching/advisorStore/epics/createMeetingEpic'
import { cancelMeetingEpic } from 'components/features/coaching/advisorStore/epics/cancelMeetingEpic'
import { deleteMeetingEpic } from 'components/features/coaching/advisorStore/epics/deleteMeetingEpic'
import { getAdvisorTimeslotsEpic } from 'components/features/coaching/advisorStore/epics/getAdvisorTimeslotsEpic'
import { subscribeAndCreateMeetingEpic } from 'components/features/coaching/advisorStore/epics/subscribeAndCreateMeetingEpic'
import { signupEpic } from 'components/features/coaching/advisorStore/epics/signupEpic'
import { meetingsListRequestEpic } from 'components/features/coaching/advisorStore/epics/meetingsListEpic'
import { getMeetingsInfoEpic } from 'components/features/coaching/advisorStore/epics/getMeetingsInfoEpic'
import { getPublicAdvisorEpic } from 'components/features/coaching/advisorStore/epics/getPublicAdvisorEpic'
import { getAdvisorReviewsEpic } from 'components/features/coaching/advisorStore/epics/getAdvisorReviewsEpic'
import { patchReviewEpic } from 'components/features/coaching/advisorStore/epics/patchReviewEpic'
import { getPublicProfileTimeslotsEpic } from 'components/features/coaching/advisorStore/epics/getPublicProfileTimeslotsEpic'
import { getTopAdvisorsEpic, getTopAdvisorsReviewsEpic } from 'components/features/coaching/advisorStore/epics/advisorsLandingEpics'
import { finishSignupEpic } from 'components/features/coaching/advisorStore/epics/finishSignupEpic'
import { meetingCTAEpic } from 'components/features/coaching/advisorStore/epics/meetingCTAEpic'
import { getMeetingEpic, meetingPaneGetMeetingFail } from 'components/features/coaching/advisorStore/epics/getMeetingEpic'

export const advisorEpic = combineEpics(
  getAdvisorsEpic,
  createMeetingEpic,
  cancelMeetingEpic,
  deleteMeetingEpic,
  getAdvisorTimeslotsEpic,
  subscribeAndCreateMeetingEpic,
  signupEpic,
  meetingsListRequestEpic,
  getMeetingsInfoEpic,
  getPublicAdvisorEpic,
  getAdvisorReviewsEpic,
  patchReviewEpic,
  getPublicProfileTimeslotsEpic,
  getTopAdvisorsEpic,
  getTopAdvisorsReviewsEpic,
  finishSignupEpic,
  meetingCTAEpic,
  getMeetingEpic,
  meetingPaneGetMeetingFail,
)
